import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { NormatividadService } from 'src/app/servicios/normatividad.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { Mensajes } from 'src/app/Class/mensajes';
import { Router, ActivatedRoute} from '@angular/router';
import { Loading } from 'src/app/Class/Loading';

declare var $: any;
@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.css']
})
export class CrearNComponent implements OnInit {
  public norma: FormGroup;
  public novedades: FormGroup;
  public tipos_norma: Observable<Object>;
  public anios: any = [];
  public unidades_organizativas: any = [];
  public programas: any = [];
  public facultades: any = [];
  public estamentos: any = [];
  public tipos_accion: any = [];
  public palabras_clave: any = [];
  public entidades: any = [];
  public normas_ant: any = [];
  public aux_norma_ant: any = [];
  public dateNow: Date;
  public tipo_id: number;
  public fieldArray: Array<any> = [];
  public nombre_norma: any;
  public interna:any;
  public instrucciones: any = [];
  public supervisor: any = [];
  public tipo_conv: any = [];
  public clasificacion_conv: any = [];
  public factores: any = [];
  public politicas: any = [];
  router: any; 
  
  constructor(private normatividadService: NormatividadService, private form: FormBuilder, private route: Router, 
    private rout: ActivatedRoute, public loading: Loading) {   
    
    this.loading.estado = true;

    this.norma = this.form.group({
      anios_selected:  ['',Validators.required],
      tipos_norma_selected: ['', Validators.required],
      fecha_expedicion:['', Validators.required],
      fecha_vigencia:[''],
      titulo: ['', Validators.required],
      numero:[''],
      descripcion:[''],
      archivo:[''],
      unidades_organizativas_selected:  [''],
      facultades_selected: [''],
      programas_selected: [''],
      estamentos_selected: [''],
      palabras_clave_selected: [''],
      entidad_selected: [''],
      instrucciones_selected:[''],
      publico_selected:[''],
      tipo_supervisor_selected:[''],
      supervisor_selected: [''],
      unidades_organizativas_supervisor_selected:[''],
      facultades_supervisor_selected:[''],
      programas_supervisor_selected:[''],
      contratista_convenio:[''],
      folios_convenio:[''],
      ubicacion_convenio:[''],
      objeto_convenio: [''],
      valor_convenio:[''],
      tipo_convenio_selected: [''],
      clasificacion_convenio_selected: [''],
      institucion_convenio_selected: [''],
      factores_selected: [''],
      politicas_selected: [''],
      aportes: [''],
      condiciones_liquidacion: [''],
      asesor_juridico: [''],
      supervisor_operativo: [''],
      supervisor_financiero: [''],
      aporte_contraparte: [''],
      aporte_efectivo_uni: [''],
      aporte_especies_uni: [''],
      certificado_disponibilidad: [''],
      certificado_presupuestal: [''],
      condiciones_manejo_recursos: [''],
      condiciones_manejo_rendimientos: [''],
      condiciones_cubrimiento: [''],
      condiciones_apalancamiento: [''],
      gestion_cobro_desembolso: [''],
      gestion_cobro_recuperacion: [''],

    });
    this.novedades = this.form.group({
      accion:  ['', Validators.required],
      norma_ant: ['', Validators.required],
      observacion: [''],
      externa: ['', Validators.required],
    })
    
    this.rout.queryParams.subscribe(params => { this.tipo_id = params['id']; });
    
    this.normatividadService.getTipoNorma(this.tipo_id).subscribe(data => {
      if(data['success']){
        this.nombre_norma  = data['nombreNorma'];
        this.interna = data['interna']
        this.norma.get('tipos_norma_selected').setValue(this.tipo_id);
      }else{
        Swal.fire({ type: 'error', title:'Error',  text: 'Tipo de norma no disponible',  showConfirmButton: false, timer: 1500 });
        this.route.navigate(['/dashboard']);
      }
    });
    this.normatividadService.getDatosSelect()
    .subscribe(data => {
      this.tipos_norma = data['tipos_norma'];
      this.anios = data['anios'];
      this.unidades_organizativas = data['unidades_organizativas'];
      this.programas = data['programas'];
      this.facultades = data['facultades'];
      this.estamentos = data['estamentos'];
      this.tipos_accion = data['tipos_accion'];
      this.palabras_clave = data['palabras_clave'];   
      this.aux_norma_ant = data['normas_ant'];      
      this.entidades= data['entidades'];
      this.instrucciones = data['instrucciones'];
      this.supervisor = data['personas'];
      this.tipo_conv = data['tipo_conv'],
      this.clasificacion_conv = data['clasificacion_conv'],
      this.factores = data['factores'],
      this.politicas = data['politicas']

      this.loading.estado = false;
    });  
  }

  ngOnInit() {
    if (this.isConvenio()){
      this.norma.get('fecha_vigencia').setValidators(Validators.required);
    }
  }

  isConvenio(){
    if(this.tipo_id == 13 || this.tipo_id == 16){
      return true;
    }
    return false;
  }
  
  filtrarNorma(interna) {
    $('#modalNovedad').modal({ backdrop: 'static', keyboard: true, show: true });
    if(interna==1){
      this.normas_ant = this.aux_norma_ant.filter(row=>row.interna == true && row.tipo_id==this.tipo_id);
    }
    else{
      this.normas_ant = this.aux_norma_ant.filter(row=>row.interna == false); 
    }   
  }
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.norma.get('archivo').setValue(file);
    }
  } 
  addFieldValue() { 
    this.fieldArray.push() 
    //this.newAttribute = {}; 
  } 
  objetoTabla(){
    this.fieldArray.push(this.novedades.value);
    this.novedades.reset();
    $('#modalNovedad').modal('hide');
  }
  deleteFieldValue(index) { 
    this.fieldArray.splice(index, 1); 
  } 
  addTagPalabra(nombre) {
    return { nombre: nombre, tag: true };
  }
  publicar(){
    this.norma.value['publico_selected'] = true;
    this.guardarNorma();
  }
  guardarNorma() {    
    var formData = new FormData();
    if (!this.norma.valid) {
      Swal.fire({ type: 'error', title:'Error', text: 'Verifique los datos e intente nuevamente', showConfirmButton: false, timer: 1500 });
    }    
    else {
      this.loading.estado = true;
      if(this.norma.value['fecha_vigencia']==null){this.norma.value['fecha_vigencia']=''}
      if(this.norma.value['numero']==null){this.norma.value['numero']=''}
      if(this.norma.value['publico_selected']==null || this.norma.value['publico_selected']==''){this.norma.value['publico_selected']=false}
      
      for( var nombre in this.norma.value ) { 
        if(nombre == "programas_selected" || nombre == "facultades_selected" || nombre == "unidades_organizativas_selected"
        || nombre == "estamentos_selected" || nombre == "palabras_clave_selected" || nombre == "instrucciones_selected" 
        || nombre == "supervisor_selected" || nombre== "factores_selected" || nombre == "tipo_convenio_selected"
        || nombre == "clasificacion_convenio_selected" || nombre == "institucion_convenio_selected" || nombre == "politicas_selected"
        || nombre == " supervisor_selected" || nombre == "unidades_organizativas_supervisor_selected"
        || nombre == "facultades_supervisor_selected" || nombre == "programas_supervisor_selected"
        ){
          for(var j=0; j<this.norma.value[nombre].length;j++){
            formData.append(nombre+'[]', this.norma.value[nombre][j]); 
          }
        }
        else{
          formData.append(nombre, this.norma.value[nombre]); 
        }
      }
      var dataAux =[];
      for( var i=0; i<this.fieldArray.length;i++)
      {
        dataAux.push({
          accion: this.fieldArray[i].accion.id,
          norma_ant: this.fieldArray[i].norma_ant.id,
          observacion: this.fieldArray[i].observacion,
        });
      }
      formData.append("normas_mod", JSON.stringify(dataAux));
      this.normatividadService.guardarNorma(formData)
      .subscribe(data => {
        if(data['success'] == true){
          Swal.fire({ type: 'success', title: Mensajes.guardar.titulo, showConfirmButton: false, timer: 1500 });
          this.route.navigate(['/normatividad/listadoNormas/'+this.tipo_id]);
        }
        else{
          Swal.fire({ type: 'error', title:'Error', text: 'Los datos no fueron ingresados', showConfirmButton: false, timer: 1500});
        }
        this.loading.estado = false;      
      });
    }
  }

}
